import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M3.371 11.38c.072.433.182.846.316 1.241C1.505 11.525 0 9.271 0 6.667A6.674 6.674 0 0 1 6.667 0a6.674 6.674 0 0 1 6.666 6.667c0 .497-.059.98-.162 1.447a3 3 0 0 0-.771-.113h-.575c.11-.427.176-.873.176-1.334a5.34 5.34 0 0 0-5.334-5.334 5.34 5.34 0 0 0-5.334 5.334 5.32 5.32 0 0 0 2.009 4.163c-.005.183 0 .366.03.55M16 13.142c0 1.187-1.038 2.19-2.267 2.19h-1.822c-.382.446-.37.415-.62.667H7.479c-.308-.33-2.257-1.978-2.792-4.837A1.55 1.55 0 0 1 5.04 9.91a1.63 1.63 0 0 1 1.247-.578l6.112.002c.488 0 .949.216 1.263.593.294.353.416.81.335 1.25l-.038.17c1.261.073 2.041.742 2.041 1.795m-3.314-2.208c.025-.145-.15-.271-.287-.267l-6.112-.001c-.147.004-.301.109-.284.28.288 1.749 1.548 3.222 2.017 3.72h2.705c.455-.513 1.638-1.984 1.961-3.732m1.98 2.208q-.002-.475-.933-.476h-.184a10 10 0 0 1-.68 1.333h.865c.497 0 .933-.4.933-.857M7.334 2.667H6V6H4v1.333h3.333z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }